<template>
  <div class="account">
    <div>
      <div class="account__card">
        <h3>Subject: Low Staff Turnout</h3>
        <p>Proin id urna nulla. Pellentesque et elit sit amet orci vulputate sagittis eget id mi. Maecenas ut nibh in felis faucibus tincidunt in nec tellus. Maecenas enim dolor..</p>
        <span>
          <routerLink to="/message-thread">View Message</routerLink>
        </span>
      </div>

      <div class="account__card">
        <h3>Subject: Low Staff Turnout</h3>
        <p>Proin id urna nulla. Pellentesque et elit sit amet orci vulputate sagittis eget id mi. Maecenas ut nibh in felis faucibus tincidunt in nec tellus. Maecenas enim dolor..</p>
        <span>
          <routerLink to="/message-thread">View Message</routerLink>
        </span>
      </div>

      <div class="account__card">
        <h3>Subject: Low Staff Turnout</h3>
        <p>Proin id urna nulla. Pellentesque et elit sit amet orci vulputate sagittis eget id mi. Maecenas ut nibh in felis faucibus tincidunt in nec tellus. Maecenas enim dolor..</p>
        <span>
          <routerLink to="/message-thread">View Message</routerLink>
        </span>
      </div>
    </div>
    <div>
      <div class="account__card--btn">
        <div>
          <routerLink to="/new-message">
            <div>
              <font-awesome-icon icon="plus" />
            </div>
            <p>Send New Message</p>
          </routerLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountOfficer"
};
</script>

<style lang="scss" scoped>
.account {
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
  background-color: #ffffff;
  padding: 20px;

  > div {
    > .account__card {
      border-radius: 3px;
      box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
      background-color: #fbfafa;
      padding: 10px;
      margin-bottom: 30px;

      > h3 {
        font-size: 1.25vw;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.17;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      > p {
        font-size: 1.042vw;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        margin: 15px 0;
        color: #000000;
      }

      > span {
        font-size: 0.833vw;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: left;
        color: #5099de;

        > a {
          text-decoration: underline;
          color: #5099de;
        }
      }
    }

    > .account__card--btn {
      overflow: hidden;

      > div {
        width: 10.417vw;
        float: right;

        > a {
          text-decoration: none;
          > div {
            width: 40px;
            height: 40px;
            border: solid 1px #f17d6b;
            margin: auto;
            border-radius: 60px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            color: #f17d6b;
            margin-top: 10px;
          }

          > p {
            font-size: 1.042vw;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #f17d6b;
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>